
export const isAuthorized = (roles = {}, authorized = []) => {
  return authorized.some(value => roles?.name === value);
};